import { SharingResult, SharingResultDebit } from '@/app/models/sharingResult';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Collapse, IconButton, Table, TableBody, TableCell, TableRow, Tooltip, styled } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const formatter = new Intl.NumberFormat('pt-BR');

const RowTableRow = styled(TableCell)(() => ({
  fontSize: 13,
  backgroundColor: 'white',
  borderBottom: 'none',
}));

const RowTableCell = styled(TableCell)(() => ({
  fontSize: 13,
  backgroundColor: '#fafafa',
  borderBottom: 'none',
}));

function ExpandableSharingDetailRow(props: { row: SharingResult }) {
  const { t } = useTranslation(['sharingDetail', 'common']);

  const { row } = props;
  const [open, setOpen] = useState(false);
  return (
    <>
      <TableRow
        sx={{
          '& > *': { borderBottom: 'unset' },
          backgroundColor: '#f9f9f9',
          cursor: 'pointer',
        }}
        onClick={() => setOpen(!open)}
      >
        <RowTableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>

          {`${row.projectCode} - ${row.projectName}`}
        </RowTableCell>
        <RowTableCell>{`R$ ${formatter.format(row.value)}`}</RowTableCell>
        <RowTableCell sx={{ color: 'blue' }}>{t(row.operation)}</RowTableCell>
        <RowTableCell>{`${row.expenseCode} - ${row.expenseName}`}</RowTableCell>
        <RowTableCell>
          <Tooltip
            arrow
            enterDelay={200}
            placement="top-end"
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: '#F7F7F7',
                  minWidth: '30rem',
                  border: '1px solid #D9D9D9',
                  color: 'black',
                  '& .MuiTooltip-arrow': {
                    color: '#F7F7F7',
                    '&:before': {
                      border: '1px solid #D9D9D9',
                    },
                  },
                },
              },
            }}
            title={row.supplier}
          >
            <span>{`${row.supplier.slice(0, 70)}...`}</span>
          </Tooltip>
        </RowTableCell>
      </TableRow>

      {open && (
        <TableRow>
          <TableCell style={{ padding: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box>
                <Table size="small" aria-label="sub-items" padding="none">
                  <TableBody>
                    {JSON.parse(row.debits)?.map((subRow: SharingResultDebit) => (
                      <TableRow key={subRow.projectCode} sx={{ backgroundColor: 'white' }}>
                        <RowTableRow
                          component="th"
                          scope="row"
                          sx={{
                            paddingLeft: 5,
                            paddingRight: (theme) => theme.spacing(2),
                            paddingTop: (theme) => theme.spacing(1),
                            paddingBottom: (theme) => theme.spacing(1),
                            width: '20.5%',
                          }}
                        >
                          {subRow.projectCode}
                        </RowTableRow>
                        <RowTableRow
                          align="left"
                          sx={{
                            paddingTop: (theme) => theme.spacing(1),
                            paddingBottom: (theme) => theme.spacing(1),
                            width: '7.5%',
                          }}
                        >
                          {`R$ ${formatter.format(subRow.value)}`}
                        </RowTableRow>
                        <RowTableRow
                          align="left"
                          sx={{
                            color: 'red',
                            fontWeight: 'medium',
                            paddingTop: (theme) => theme.spacing(1),
                            paddingBottom: (theme) => theme.spacing(1),
                            width: '63.5%',
                          }}
                        >
                          {t('DEBIT')}
                        </RowTableRow>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}

export default ExpandableSharingDetailRow;
